// extracted by mini-css-extract-plugin
export var discard = "_1q-4";
export var muiTooltipTooltip = "_1q-6";
export var notificationBar = "_1q-3";
export var notificationContainer = "_1q-2";
export var saveButtonHoverSlotWrapper = "_1q-5";
export var show = "_1q-1";
export var spacer = "_1q-0";